import { useMutation } from '@tanstack/react-query';
import { message } from 'antd';
import { API } from 'network/api';
import { MutationConfig } from 'types/request';
import { handleAxiosError } from 'utils/helpers';

type UploadDocumentConfig = MutationConfig & {
  successMessage?: string;
  errorMessage?: string;
};

type DocumentUploadPayload = {
  file: Blob;
  objectClass: string;
  objectId: string;
  tag: string;
};

const useUploadDocument = (config?: UploadDocumentConfig) => {
  const mutation = useMutation({
    mutationFn: (data: DocumentUploadPayload) => {
      const formData = new FormData();
      formData.append('file', data.file);
      formData.append('objectClass', data.objectClass);
      formData.append('objectId', data.objectId);
      formData.append('tag', data.tag);
      return API.post('/documents/upload', data, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
    },
    onSuccess: () => {
      config?.onSuccess?.();
      if (config?.successMessage) message.success(config?.successMessage);
    },
    onError: (error) => {
      config?.onError?.();
      handleAxiosError(
        error,
        config?.errorMessage ?? 'There were some errors uploading the file',
      );
    },
    onSettled: () => {
      config?.onFinish?.();
    },
  });

  return mutation;
};

export default useUploadDocument;
